'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createDecoratedClass = (function () { function defineProperties(target, descriptors, initializers) { for (var i = 0; i < descriptors.length; i++) { var descriptor = descriptors[i]; var decorators = descriptor.decorators; var key = descriptor.key; delete descriptor.key; delete descriptor.decorators; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor || descriptor.initializer) descriptor.writable = true; if (decorators) { for (var f = 0; f < decorators.length; f++) { var decorator = decorators[f]; if (typeof decorator === 'function') { descriptor = decorator(target, key, descriptor) || descriptor; } else { throw new TypeError('The decorator for method ' + descriptor.key + ' is of the invalid type ' + typeof decorator); } } if (descriptor.initializer !== undefined) { initializers[key] = descriptor; continue; } } Object.defineProperty(target, key, descriptor); } } return function (Constructor, protoProps, staticProps, protoInitializers, staticInitializers) { if (protoProps) defineProperties(Constructor.prototype, protoProps, protoInitializers); if (staticProps) defineProperties(Constructor, staticProps, staticInitializers); return Constructor; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _assert = require('./assert');

var _assert2 = _interopRequireDefault(_assert);

var _sanitize = require('./sanitize');

var _sanitize2 = _interopRequireDefault(_sanitize);

var _result = require('./result');

var _result2 = _interopRequireDefault(_result);

/*******************************************************************************
 * The transaction can either be a blocking or non blocking
 */
var Mode = Object.freeze({
	BLOCKING: 'TRANSACTION_MODE_BLOCKING',
	NON_BLOCKING: 'TRANSACTION_MODE_NON_BLOCKING'
});

/*******************************************************************************
 * The Transaction class is a helper class to manage pending queries. It has
 * a similar api to a promise but also includes the resolve/reject methods
 * like a deferred object would.
 *
 * TODO: Look into actually extending the Promise class. Can we do it neatly
 * 	     or would it require 'hacky' solutions.
 */

var Transaction = (function () {
	_createClass(Transaction, null, [{
		key: 'Mode',
		get: function get() {
			return Mode;
		}
	}]);

	function Transaction() {
		var mode = arguments.length <= 0 || arguments[0] === undefined ? Mode.BLOCKING : arguments[0];
		var resume = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

		_classCallCheck(this, Transaction);

		this.mode = mode;
		this.complete = false;
		this.error = null;
		this.result = new _result2['default'](false);
		this.onComplete = [];
		this.onError = [];
		this.doResume = mode === Mode.NON_BLOCKING ? resume : null;

		if (mode === Mode.NON_BLOCKING && typeof this.doResume !== 'function') {
			throw new Error('Transaction: Resume method was not supplied to non-blocking transaction');
		}

		// console.log('Transaction.create');
		// console.log(' -- mode =', this.mode);
	}

	_createDecoratedClass(Transaction, [{
		key: 'resume',
		decorators: [_autobindDecorator2['default']],
		value: function resume() {
			if (this.mode === Mode.BLOCKING) {
				throw new Error('Transaction: Cannot resume a blocking transaction');
			}
			if (typeof this.doResume === 'function') {
				this.doResume(this);
			}
			this.doResume = null;
		}
	}, {
		key: 'resolve',
		decorators: [_autobindDecorator2['default']],
		value: function resolve(value) {
			var _this = this;

			if (this.complete) {
				throw new Error('Attempting to resolve a completed transaction');
			}

			// console.log('Transaction.resolve');
			// console.log(' -- value =', value);

			try {
				var sanitized = (0, _sanitize2['default'])(value);
				value = sanitized;
			} catch (e) {
				console.log('-> Error sanitizing value');
				console.log(e.stack);
			}

			this.complete = true;
			this.result = new _result2['default'](true, value);

			this.onComplete.forEach(function (fn) {
				return fn(_this.result);
			});
		}
	}, {
		key: 'reject',
		decorators: [_autobindDecorator2['default']],
		value: function reject(error) {
			var _this2 = this;

			if (this.complete) {
				throw new Error('Attempting to reject a completed transaction');
			}

			this.complete = true;
			this.error = error;
			this.result = new _result2['default'](true, null, error);

			this.onError.forEach(function (fn) {
				return fn(_this2.result);
			});
		}
	}, {
		key: 'then',
		decorators: [_autobindDecorator2['default']],
		value: function then(cb) {
			var _this3 = this;

			if (this.complete && !this.error) {
				setTimeout(function () {
					return cb(_this3.result);
				}, 1);
			} else if (!this.complete) {
				this.onComplete.push(cb);
			}
			return this;
		}
	}, {
		key: 'catch',
		decorators: [_autobindDecorator2['default']],
		value: function _catch(cb) {
			var _this4 = this;

			if (this.complete && this.error) {
				setTimeout(function () {
					return cb(_this4.error);
				}, 1);
			} else if (!this.complete) {
				this.onError.push(cb);
			}
			return this;
		}
	}, {
		key: 'observe',
		decorators: [_autobindDecorator2['default']],
		value: function observe(fn) {
			this.then(fn)['catch'](fn);
			return this;
		}
	}, {
		key: 'unobserve',
		decorators: [_autobindDecorator2['default']],
		value: function unobserve(fn) {
			var indexComplete = this.onComplete.indexOf(fn);
			var indexError = this.onError.indexOf(fn);

			if (indexComplete > -1) {
				this.onComplete.splice(indexComplete, 1);
			}

			if (indexError > -1) {
				this.onError.splice(indexError, 1);
			}
			return this;
		}
	}, {
		key: 'asPromise',
		value: function asPromise() {
			var _this5 = this;

			return new Promise(function (resolve, reject) {
				_this5.then(resolve)['catch'](reject);
			});
		}
	}]);

	return Transaction;
})();

exports['default'] = Transaction;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/acast-reactor/dist/transaction.js
// module id = 5QNW
// module chunks = 15